import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#141614] border-t border-[#323632] px-4 sm:px-8 lg:px-16 py-10" data-testid="site-footer">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6"
      >
        <div className="text-center sm:text-left">
          <div className="inline-flex bg-white rounded-xl px-4 py-2.5" data-testid="footer-logo-card">
            <img src="/logo.jpg" alt="LLP Zaun&Garten Logo" className="h-10 w-auto" />
          </div>
          <p className="text-xs text-[#A1A49D] mt-3">
            Inhaber: Anatoli Zygankow · Hummelbecker Str. 18 · 32429 Minden
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-5 gap-y-3 text-xs text-[#A1A49D]">
          <a href="#leistungen" data-testid="footer-link-services" className="hover:text-white transition-colors">
            Leistungen
          </a>
          <a href="#termin" data-testid="footer-link-booking" className="hover:text-white transition-colors">
            Termin
          </a>
          <a href="#kontakt" data-testid="footer-link-contact" className="hover:text-white transition-colors">
            Kontakt
          </a>
          <a href="/impressum" data-testid="footer-link-impressum" className="hover:text-white transition-colors">
            Impressum
          </a>
          <a href="/datenschutz" data-testid="footer-link-datenschutz" className="hover:text-white transition-colors">
            Datenschutz
          </a>
          <a href="/admin" data-testid="footer-link-admin" className="hover:text-white transition-colors">
            Admin
          </a>
          <a
            href="#start"
            data-testid="footer-back-to-top"
            aria-label="Nach oben scrollen"
            className="w-10 h-10 rounded-full border border-[#323632] flex items-center justify-center hover:border-[#C89D66] hover:text-[#C89D66] transition-colors"
          >
            <ArrowUp className="w-4 h-4" />
          </a>
        </div>
      </motion.div>
    </footer>
  );
}
